import { render, staticRenderFns } from "./raw_materials.vue?vue&type=template&id=81aa1054&scoped=true"
import script from "./raw_materials.vue?vue&type=script&lang=js"
export * from "./raw_materials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aa1054",
  null
  
)

export default component.exports